import { FrenchLegalStatus } from '../enums/frenchLegalStatus'

type ParsedLegalStatus = {
  legalStatusCustom: string | undefined
  legalStatusOption: FrenchLegalStatus | undefined
}

export const parseLegalStatus = (
  initialLegalStatus: string | null | undefined | FrenchLegalStatus,
): ParsedLegalStatus => {
  if (!initialLegalStatus) {
    return { legalStatusCustom: undefined, legalStatusOption: undefined }
  }

  if (initialLegalStatus in FrenchLegalStatus) {
    return {
      legalStatusOption: initialLegalStatus as FrenchLegalStatus,
      legalStatusCustom: undefined,
    }
  }

  return { legalStatusOption: FrenchLegalStatus.Other, legalStatusCustom: initialLegalStatus }
}
